<template>
  <v-app>
    <loading :active.sync="isLoading" background-color="#ababab" color="#330066" loader="spinner" />

    <app-navigation v-if="!hideNavigation" />

    <v-col>
      <v-flex class="v-content" style="padding-left: 56px; height: 44px;">
        <v-layout>
          <v-flex v-if="loggedIn" shrink style="padding-top: 10px; padding-right: 20px;">
            <v-menu v-model="menu" :close-on-content-click="false" offset-y>
              <template v-slot:activator="{ on }">
                <v-btn small color="white" light v-on="on">Messages</v-btn>
              </template>

              <v-card>
                <v-list>
                  <v-list-item>
                    <v-list-item-content>
                      <v-list-item-title>Chat</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-content>
                      <v-btn
                        @click="messageDialog = true"
                        class="text-none"
                        small
                      >Message All Drivers</v-btn>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>

                <v-divider></v-divider>

                <v-flex px-2>
                  <v-text-field
                    hide-details
                    append-icon="search"
                    v-model="filter"
                    placeholder="Search"
                  ></v-text-field>
                </v-flex>
                <v-list class="overflow-y-auto" max-height="400">
                  <v-list-item
                    @click="function() {menu = false; driverChannelSelected(channel);}"
                    style="height: 24px;"
                    v-for="channel in localChannelsFiltered"
                  >
                    <p style="fontSize: 12px;">
                      <b>{{ channel.state.friendlyName }}</b>
                    </p>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-menu>
          </v-flex>
          <v-chip-group :show-arrows="true" style="width: calc(100vw - 400px);">
            <v-chip
              v-for="channel in tc.activeChannels"
              :key="channel.sid"
              close
              @click:close="closeChannel(channel)"
              @click="driverChannelSelected(channel)"
              :color="colorForChannel(channel)"
            >{{ channel.state.friendlyName }}</v-chip>
          </v-chip-group>
        </v-layout>
      </v-flex>
      <v-dialog v-model="messageDialog" width="600px">
        <MessageAllDriversDialog @sent="sendMessageToAllDrivers" />
      </v-dialog>
      <v-content id="main" transition="slide-x-transition">
        <router-view />
      </v-content>
    </v-col>
    <div id="whoLogged">{{ name }}</div>
    <audio id="ding" src="/sound/ding.wav">
      Your browser does not support the
      <code>audio</code> element.
    </audio>
    <div>
      <beautiful-chat
        v-if="openChat && loggedIn"
        :isOpen="openChat"
        :participants="[]"
        :messageList="messageList"
        :open="function(){ openChat = true;}"
        :close="closeChat"
        :showLauncher="false"
        :edit="null"
        :onMessageWasSent="messageSent"
        :alwaysScrollToBottom="true"
        :colors="colors"
        @scrollToTop="scrollToTop"
      >
        <!-- <template v-slot:text-message-body="{ message }">
          <p style="color: black;">{{message.data.text}}</p>
        </template>-->
        <template v-slot:header>
          <h3
            style="height: 32px; padding-top: 12px;"
          >{{ tc.currentChannel != null ? tc.currentChannel.state.friendlyName : "" }}</h3>
        </template>
      </beautiful-chat>
    </div>
  </v-app>
</template>

<script>
import AppNavigation from "@/components/AppNavigation";
import Loading from "vue-loading-overlay";

import MessageAllDriversDialog from "@/components/widget/menu/MessageAllDriversDialog.vue";

import "vue-loading-overlay/dist/vue-loading.css";

import qs from "qs";
import axios from "axios";
axios.defaults.withCredentials = true;

import moment from "moment";

export default {
  name: "App",
  components: {
    AppNavigation,
    Loading,
    MessageAllDriversDialog
  },
  data: function() {
    return {
      filter: "",
      menu: false,
      fullPage: true,
      openChat: false,
      accessToken: null,
      tc: {
        subscribedChannels: [],
        currentChannel: null,
        currentChannelMessages: null,
        activeChannels: [],
        localChannels: []
      },
      prefix: "",
      messageList: [],
      identity: "",
      colors: {
        header: {
          bg: "#000000",
          text: "#ffffff"
        },
        launcher: {
          bg: "#000000"
        },
        messageList: {
          bg: "#ffffff"
        },
        sentMessage: {
          bg: "#4e8cff",
          text: "#ffffff"
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222"
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867"
        }
      },
      messageDialog: false
    };
  },
  computed: {
    loggedIn: function() {
      return this.$store.getters.getLoggedIn;
    },
    name: function() {
      return this.$store.getters.getName;
    },
    isLoading: function() {
      return this.$store.state.loading;
    },
    driverToMessage: function() {
      return this.$store.state.driverToMessage;
    },
    localChannelsFiltered: function() {
      if (this.filter == null || this.filter == "") {
        return this.tc.localChannels;
      }

      var filter = this.filter;

      return this.tc.localChannels.filter(function(f) {
        return f.state.friendlyName
          .toLowerCase()
          .includes(filter.toLowerCase());
      });
    }
  },
  watch: {
    driverToMessage(newDriver, oldDriver) {
      console.log("Driver to message changed " + newDriver);

      if (newDriver != null) {
        this.openChat = true;

        var self = this;

        this.tc.messagingClient
          .getChannelByUniqueName(this.prefix + newDriver)
          .then(function(c) {
            console.log("GOT UNIQUE CHANNEL");
            console.log(c);
            self.tc.currentChannel = c;

            if (
              !self.tc.activeChannels.some(function(activeChannel) {
                return activeChannel.sid == c.sid;
              })
            ) {
              self.tc.activeChannels.push(c);
              console.log("Newly active channel");
            }

            c.getMessages(15).then(function(messages) {
              self.tc.currentChannelMessages = messages;

              c.setAllMessagesConsumed();

              console.log(messages);

              var ml = [];

              for (var i = 0; i < messages.items.length; i++) {
                var msg = messages.items[i];

                ml.push({
                  author: msg.author == self.identity ? "me" : msg.author,
                  type: "text",
                  id: msg.sid,
                  data: {
                    text: msg.body,
                    meta: moment(msg.timestamp).format("YYYY-MM-DD HH:mm")
                  },
                  index: msg.index
                });
              }

              self.messageList = ml;

              console.log(self.messageList);
            });
          });
      }
    }
  },
  beforeMount() {
    document.title = process.env.VUE_APP_TITLE;
    this.$store.dispatch("checkAuth");
  },
  mounted: function() {
    this.$store.state.driverToMessage = null;
    this.fetchAccessToken();
  },
  methods: {
    async sendMessageToAllDrivers(message) {
      try {
        var url = `${this.$store.state.apiUrl}/chat/getChannelsForDrivers`;

        let response = await axios.get(url, {
          params: {}
        });

        if (response.data.error == "no_error") {
          var ids = response.data.channelSids;
          console.log(ids);

          var tc = this.tc;

          // for (var i = 0; i < 5; i++) {
          for (var i = 0; i < this.tc.subscribedChannels.length; i++) {
            const lc = this.tc.subscribedChannels[i];

            var oldMessages =
              lc.state.lastMessage != null &&
              lc.state.lastConsumedMessageIndex < lc.state.lastMessage.index;

            if (ids.indexOf(lc.sid) >= 0) {
              if (!oldMessages) {
                lc.sendMessage(message).then(function(m) {
                  lc.setAllMessagesConsumed();
                });
              }
            } else {
            }
          }
        } else {
          alert("Error sending to all drivers");
        }

        this.loading = false;
      } catch (error) {
        alert("Error sending to all drivers");
        this.loading = false;
      }

      this.messageDialog = false;
    },
    colorForChannel(c) {
      if (
        c.state.lastMessage != null &&
        c.state.lastConsumedMessageIndex < c.state.lastMessage.index
      ) {
        return "blue lighten-2";
      } else {
        return "grey lighten-2";
      }
    },
    driverChannelSelected(channel) {
      this.filter = "";

      var driverIDString = channel.state.uniqueName.replace(this.prefix, "");
      console.log(driverID);

      var driverID = Number(driverIDString);

      this.$store.state.driverToMessage = driverID;
    },
    closeChannel(channel) {
      for (var i = 0; i < this.tc.activeChannels.length; i++) {
        var activeChannel = this.tc.activeChannels[i];

        if (activeChannel.sid == channel.sid) {
          this.tc.activeChannels.splice(i, 1);
        }
      }

      if (
        this.tc.currentChannel != null &&
        this.tc.currentChannel.sid == channel.sid
      ) {
        this.closeChat();
      }
    },
    closeChat() {
      console.log("Closing Chat");
      this.openChat = false;
      this.$store.state.driverToMessage = null;
      var channel = this.tc.currentChannel;
      this.tc.currentChannel = null;

      // for (var i = 0; i < this.tc.activeChannels.length; i++) {
      //   var activeChannel = this.tc.activeChannels[i];

      //   if (activeChannel.sid == channel.sid) {
      //     this.tc.activeChannels.splice(i, 1);
      //   }
      // }
    },
    async fetchAccessToken() {
      console.log("Fetch Access Token");
      try {
        var url = `${this.$store.state.apiUrl}/chat/getAuthToken`;

        let response = await axios.get(url, {
          params: {}
        });

        if (response.data.accessToken != null) {
          this.accessToken = response.data.accessToken;
          this.prefix = response.data.prefix;
          this.identity = response.data.identity;

          if (this.tc.messagingClient == null) {
            this.initialiseChat(this.accessToken);
          } else {
            this.setNewToken(this.accessToken);
          }
        } else {
          setTimeout(this.fetchAccessToken, 2000);
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        setTimeout(this.fetchAccessToken, 2000);
      }
    },
    scrollToTop: function() {
      console.log(
        "TOP " + this.messageList[0].index + " " + this.messageList.length
      );

      var ml = this.messageList;
      var self = this;

      if (this.tc.currentChannelMessages.hasPrevPage) {
        this.tc.currentChannelMessages.prevPage().then(function(messages) {
          self.tc.currentChannelMessages = messages;
          for (var i = 0; i < messages.items.length; i++) {
            var msg = messages.items[i];

            ml.unshift({
              author: msg.author == self.identity ? "me" : msg.author,
              type: "text",
              id: msg.sid,
              data: {
                text: msg.body,
                meta: moment(msg.timestamp).format("YYYY-MM-DD HH:mm")
              },
              index: msg.index
            });
          }
        });
      }
    },
    messageSent: function(msg) {
      console.log(msg);
      var self = this;
      this.tc.currentChannel.sendMessage(msg.data.text).then(function(m) {});
    },
    initialiseChat: function(token) {
      var tc = this.tc;

      console.log("Initialising chat with access token " + token);

      var self = this;

      Twilio.Chat.Client.create(token)
        .then(function(client) {
          console.log("Connected to chat");
          tc.messagingClient = client;
          tc.messagingClient.on(
            "tokenAboutToExpire",
            self.refreshToken.bind(this)
          );
          tc.messagingClient.on("tokenExpired", self.refreshToken.bind(this));

          tc.messagingClient.on("messageAdded", function(m) {
            console.log(m);

            if (
              m.author != self.identity &&
              (self.tc.currentChannel == null ||
                m.channel.sid != self.tc.currentChannel.sid)
            ) {
              var thissound = document.getElementById("ding");
              thissound.currentTime = 0;
              thissound.play();
            }
          });

          tc.messagingClient.on("channelUpdated", function(cu) {
            console.log("Channel updated");
            var c = cu.channel;
            console.log(c);

            if (
              !(tc.currentChannel != null && tc.currentChannel.sid == c.sid)
            ) {
              if (
                c.state.lastMessage != null &&
                c.state.lastConsumedMessageIndex < c.state.lastMessage.index
              ) {
                console.log("UNREAD MESSAGES");

                if (
                  !self.tc.activeChannels.some(function(activeChannel) {
                    return activeChannel.sid == c.sid;
                  })
                ) {
                  self.tc.activeChannels.push(c);
                  console.log("Newly active channel");
                } else {
                  console.log("Channel already active");
                }
              } else {
                console.log(
                  "Channel update not about last message -- may have been clearing read messages so close unless open!"
                );
                console.log(
                  c.lastMessage.index + " " + c.state.lastConsumedMessageIndex
                );

                for (var i = 0; i < tc.activeChannels.length; i++) {
                  const activeChannel = tc.activeChannels[i];

                  if (activeChannel.sid == c.sid) {
                    tc.activeChannels.splice(i, 1);
                  }
                }
              }
            } else {
              console.log("Leave chat alone if currently open");
            }
          });

          tc.messagingClient.on("messageAdded", function(msg) {
            console.log("Message Added");
            console.log(msg);

            if (
              tc.currentChannel != null &&
              msg.channel.sid == tc.currentChannel.sid
            ) {
              self.messageList.push({
                author: msg.author == self.identity ? "me" : msg.author,
                type: "text",
                id: msg.sid,
                data: {
                  text: msg.body,
                  meta: moment(msg.timestamp).format("YYYY-MM-DD HH:mm")
                },
                index: msg.index
              });

              console.log("All messages consumed");
              tc.currentChannel.setAllMessagesConsumed();
            }
          });

          // get list of all subscribed channels
          client.getSubscribedChannels().then(function(paginator) {
            self.fetchChannels(paginator);
          });
          // listen for events on all of these channels
          // when added to a channel subscribe to it (new drivers for example)
          //
        })
        .catch(function(e) {
          console.log("Error Starting Twilio");
          console.log(e);
        });
    },
    fetchChannels(paginator) {
      for (var i = 0; i < paginator.items.length; i++) {
        var channel = paginator.items[i];
        this.tc.subscribedChannels.push(channel);

        if (channel.state.lastMessage == null) {
          console.log("LAST MESSAGE NULL");
        }

        if (
          channel.state.lastMessage != null &&
          channel.state.lastMessage.index >
            channel.state.lastConsumedMessageIndex
        ) {
          this.tc.activeChannels.push(channel);
        } else {
        }
      }

      var self = this;
      var tc = this.tc;

      if (paginator.hasNextPage) {
        console.log("Paginator has next page so fetch");
        paginator.nextPage().then(function(p) {
          console.log("Next page");
          console.log(p);
          self.fetchChannels(p);
        });
      } else {
        console.log("Paginator fully iterated");

        this.tc.messagingClient
          .getLocalChannels({ criteria: "lastMessage" })
          .then(function(channels) {
            self.tc.localChannels = channels;
          });

        setTimeout(function() {
          tc.messagingClient
            .getLocalChannels({ criteria: "lastMessage" })
            .then(function(channels) {
              tc.localChannels = channels;
            });
        }, 5000);
      }
    },
    refreshToken() {
      console.log("Token about to expire");
      this.fetchAccessToken();
    },
    setNewToken(token) {
      var self = this;
      console.log("Setting new token " + token);
      console.log(this.tc.messagingClient);
      this.tc.messagingClient
        .updateToken(token)
        .then(function(success) {
          console.log("Refreshed Access Token");
        })
        .catch(function(e) {
          console.log("Error refreshing token -- attempt getting new one");
          setTimeout(function() {
            self.fetchAccessToken();
          }, 1500);
        });
    }
  }
};
</script>

<style lang="scss">
// #main {
//   margin-left: 14px;
// }

.v-content {
  background-color: #f2f3f8;
}

#whoLogged {
  position: absolute;
  float: right;
  top: 24px;
  right: 24px;
  color: gray;
}

aside {
  box-shadow: none !important;
}

tbody tr:nth-of-type(even) {
  background-color: white;
}

p {
  padding: 0 !important;
  margin: 0 !important;
}

.add-person-button {
  padding-top: 4px;
  padding-left: 2px;
}

table.v-table thead th:first-child {
  padding: 0 4px !important;
}

table.v-table thead th:not(:first-child) {
  padding: 0 4px !important;
}

tr {
  border: 1px solid white;
  border-bottom: 0;
}

.v-date-picker-table {
  position: relative;
  padding: 0 12px;
  height: 300px !important;
}

.row {
  margin-left: 0px !important;
  margin-right: 2px !important;
}

.input-group.input-group--error label {
  animation: none !important;
}

a:link {
  text-decoration: none;
}
</style>
